// The company's payment model as the dashboard reads it (spec 2026-09-25).
// `status` is connectApi.toConnectStatus's shape, or null when it has not
// been read or could not be. Every rule here is fail-closed on null: it reads
// as a legacy company that has not started Connect, which is exactly what the
// dashboard showed before any of this.
export const CONNECT_DIRECT = 'CONNECT_DIRECT';
export const CONNECT_PENDING = 'CONNECT_PENDING';

export const isConnectDirect = (status) => status?.paymentModel === CONNECT_DIRECT;

export const isConnectPending = (status) => status?.paymentModel === CONNECT_PENDING;

// On its way to Connect and not live yet: a legacy company whose onboarding
// the admin started (it has a Stripe account), or any company born Pending —
// with or without an account, since Stripe may have been down at signup.
export const isConnectOnboarding = (status) =>
  !isConnectDirect(status) && (!!status?.hasAccount || isConnectPending(status));

// A legacy company the admin pulled into onboarding: it has a Stripe account
// but is still paid on the legacy path until Activate.
export const isLegacyOnboarding = (status) =>
  isConnectOnboarding(status) && !isConnectPending(status);

// The Finance sub-menu's feature flags (layout.js). Owner, 2026-09-25: while
// a company born Pending is onboarding its Finance is Business Details and
// nothing else; Activate brings the rest back. Owner, 2026-10-03: a legacy
// company in onboarding keeps its Overview and bank screen, because its
// money still moves on the legacy path until Activate, and gains Business
// Details. `legacyBank` stays the one inverted flag — the bank screen only a
// company still paid on the legacy path has a page for.
export const financeMenuFeatures = (status) => {
  const direct = isConnectDirect(status);
  const pending = isConnectPending(status);
  return {
    connect: !!status?.hasAccount || pending,
    connectDirect: direct,
    financeOverview: !pending,
    legacyBank: !direct && !pending,
  };
};

// The admin's "Ready to activate" badge (owner, 2026-09-25): Stripe's side is
// done and the company is not live yet. Terminals are deliberately not part
// of it — Activate lists those blockers itself.
export const isReadyToActivate = (row) =>
  !!row &&
  row.paymentModel !== CONNECT_DIRECT &&
  !!row.hasAccount &&
  !!row.chargesEnabled &&
  !!row.payoutsEnabled &&
  row.outstanding === 0;
